import { useMutation } from '@tanstack/react-query';

/**
 * Mutation hook for uploading a bulk upload file.
 *
 * @param {Object} options
 * @param {Object} options.api - API object with upload function
 * @param {Object} options.params - Additional params to pass to the API
 * @param {Function} [options.onSuccess] - Callback when upload succeeds, receives upload data
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
function useUploadFile({ api, onSuccess, params }) {
    return useMutation({
        mutationFn: async (file) => {
            const response = await api.upload(file, params);
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Upload failed');
            }
            return response.data;
        },
        onSuccess,
    });
}

export { useUploadFile };
